import { render, staticRenderFns } from "./Ordering.vue?vue&type=template&id=fa8323dc&scoped=true&"
import script from "./Ordering.vue?vue&type=script&lang=js&"
export * from "./Ordering.vue?vue&type=script&lang=js&"
import style0 from "./Ordering.vue?vue&type=style&index=0&id=fa8323dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8323dc",
  null
  
)

export default component.exports